import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {InviseoScenariosPartages} from '../../../../../../../domain/inviseo/model/inviseo-scenarios-partages';
import {InviseoWidgetUtilService} from '../../../../../../../domain/inviseo/service/inviseo-widget-util.service';

@Component({
  selector: 'app-widget-inviseo-scenarios-partages',
  templateUrl: './home-dashboard-widget-inviseo-scenarios-partages.component.html'
})
export class HomeDashboardWidgetInviseoScenariosPartagesComponent implements OnInit {

  @Input() widget: WidgetDetail | undefined;
  @Input() scenariosPartages: InviseoScenariosPartages;

  @Output() actionEvent = new EventEmitter<string>();

  constructor(private inviseoWidgetUtilService: InviseoWidgetUtilService) {
  }

  ngOnInit(): void {
  }

  public getRedirectLink(): string {
    return this.inviseoWidgetUtilService.getRedirectLinkForSharedScenario(this.scenariosPartages);
  }

}
